import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import PasswordInput from "@/components/PasswordInput";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const next = sp.get("next");
  const safeNext = next && next.startsWith("/") && !next.startsWith("//") ? next : "/perfil";
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Bem-vindo!");
      nav(safeNext);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Erro ao entrar");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#0d0d0d] text-white">
      <div className="auk-ribbon h-2" />
      <div className="flex-1 flex flex-col justify-center px-6 py-8 max-w-md mx-auto w-full">
        <Link to="/" className="text-xs text-white/60 mb-8 hover:text-white">← Voltar</Link>
        <h1 className="font-display text-3xl font-extrabold mb-1">Bem-vindo de volta</h1>
        <p className="text-sm text-white/60 mb-8">{t("tagline")}</p>

        <form onSubmit={submit} className="space-y-3">
          <input
            data-testid="login-email"
            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white placeholder-white/40 outline-none focus:border-[#c8102e] transition-colors"
          />
          <PasswordInput
            testid="login-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Palavra-passe"
            autoComplete="current-password"
          />
          <button
            data-testid="login-submit"
            type="submit" disabled={busy}
            className="w-full py-3 rounded-xl bg-[#c8102e] hover:bg-[#a50c24] disabled:opacity-50 font-semibold transition-colors"
          >
            {busy ? "A entrar..." : t("login")}
          </button>
        </form>

        <p className="text-sm text-white/60 mt-4 text-center">
          <Link to="/esqueci" data-testid="login-forgot-link" className="text-white/80 hover:text-[#ffd100] underline underline-offset-2">
            Esqueceste-te da palavra-passe?
          </Link>
        </p>

        <p className="text-sm text-white/60 mt-6 text-center">
          Ainda não tens conta? <Link to={next ? `/registar?next=${encodeURIComponent(next)}` : "/registar"} className="text-[#ffd100] font-semibold hover:underline">{t("register")}</Link>
        </p>
      </div>
    </div>
  );
}
